export default "__VITE_ASSET__B1Z4tGQJ__"